import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "synergie-cookies-consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && !localStorage.getItem(KEY)) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setVisible(false);
  };

  return (
    <div
      className="fixed bottom-16 md:bottom-4 inset-x-3 md:inset-x-auto md:right-4 md:max-w-md z-40 rounded-2xl bg-[#0D2C4D] text-white p-5 shadow-2xl border border-white/10"
      role="dialog"
      aria-label="Bannière cookies"
      data-testid="cookie-banner"
    >
      <p className="text-sm mb-3">
        Nous utilisons uniquement des <b>cookies techniques</b> nécessaires au fonctionnement du site (session, authentification).
        Aucun cookie publicitaire ni de tracking.
      </p>
      <div className="flex flex-wrap items-center gap-3 text-xs">
        <button
          onClick={accept}
          className="px-4 py-2 rounded-full bg-[#2B8B8E] hover:bg-[#1F6F73] font-semibold"
          data-testid="cookie-accept-btn"
        >
          J'ai compris
        </button>
        <Link to="/rgpd" className="underline text-white/70 hover:text-white" data-testid="cookie-more-link">
          En savoir plus
        </Link>
      </div>
    </div>
  );
}
